import script from "./sensor.vue?vue&type=script&lang=ts&setup=true"
export * from "./sensor.vue?vue&type=script&lang=ts&setup=true"

import "./sensor.vue?vue&type=style&index=0&id=3da6acfc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da6acfc"]])

export default __exports__